import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.detail.title.no-translate',
		defaultMessage: 'Heartbeat settings',
		description: 'Title of heartbeat detail focus state',
	},
	settingsDescription: {
		id: 'eoc.heartbeats.detail.description.no-translate',
		defaultMessage:
			'Continuously check the connectivity of your systems by using the <linkRestApi>Rest API</linkRestApi> or sending an email. <linkLearnMore>Learn more</linkLearnMore>.',
		description: 'Title of heartbeat detail focus state',
	},
	turOnButton: {
		id: 'eoc.heartbeats.detail.turnOn-button.no-translate',
		defaultMessage: 'Turn on heartbeat',
		description: 'Primary action button which will enable heartbeat.',
	},
	turOffButton: {
		id: 'eoc.heartbeats.detail.turnOff-button.no-translate',
		defaultMessage: 'Turn off heartbeat',
		description: 'Primary action button which will disable heartbeat.',
	},
	close: {
		id: 'eoc.heartbeats.detail.close-button.no-translate',
		defaultMessage: 'Close',
		description: 'Close button.',
	},
	edit: {
		id: 'eoc.heartbeats.detail.edit-button.no-translate',
		defaultMessage: 'Edit',
		description: 'Edit button.',
	},
	delete: {
		id: 'eoc.heartbeats.detail.delete-button.no-translate',
		defaultMessage: 'Delete',
		description: 'Delete button.',
	},
	name: {
		id: 'eoc.heartbeats.detail.name-label.no-translate',
		defaultMessage: 'Name',
		description: 'Name label will indicate the heartbeat name.',
	},
	description: {
		id: 'eoc.heartbeats.detail.description-label.no-translate',
		defaultMessage: 'Description',
		description: 'Description label will indicate the heartbeat description.',
	},
	assignedTeam: {
		id: 'eoc.heartbeats.detail.assigned-team-label.no-translate',
		defaultMessage: 'Assigned team',
		description: 'Assigned team label will indicate the which team the heartbeat belongs.',
	},
	lastPinged: {
		id: 'eoc.heartbeats.detail.last-pinged-label.no-translate',
		defaultMessage: 'Last pinged',
		description: 'Last pinged label will indicate the last time heartbeat is pinged.',
	},
	nextPing: {
		id: 'eoc.heartbeats.detail.next-ping-label.no-translate',
		defaultMessage: 'Next ping',
		description: 'Next ping label will indicate the closest time the heartbeat will be pinged.',
	},
	pingInterval: {
		id: 'eoc.heartbeats.detail.ping-interval-label.no-translate',
		defaultMessage: 'Ping interval',
		description: 'Ping interval label will indicate the interval of the heartbeat is pinged.',
	},
	status: {
		id: 'eoc.heartbeats.detail.status-label.no-translate',
		defaultMessage: 'Status',
		description: 'Status label will indicate the heartbeat status.',
	},
	alertMessage: {
		id: 'eoc.heartbeats.detail.alert-message-label.no-translate',
		defaultMessage: 'Alert message',
		description: 'Alert message label will indicate the priority and message of the alert.',
	},
	alertTags: {
		id: 'eoc.heartbeats.detail.alert-tags-label.no-translate',
		defaultMessage: 'Alert tags',
		description: 'Alert tags label will indicate the tags of alert.',
	},
	instructions: {
		id: 'eoc.heartbeats.detail.instructions.no-translate',
		defaultMessage: 'Instructions',
		description:
			'Text will be displayed at the top of the instruction panel to understand user how to use heartbeat',
	},
	apiInstruction: {
		id: 'eoc.heartbeats.detail.api-instruction.no-translate',
		defaultMessage:
			'Follow the steps below to send pings to this heartbeat with the Heartbeats API.',
		description: 'Text will give info to user about API heartbeat instructions',
	},
	apiInstructionFirstBullet: {
		id: 'eoc.heartbeats.detail.api-instruction.second-bullet.no-translate',
		defaultMessage: ' from Atlassian Account to authenticate your sender system',
		description: 'Api heartbeat second instruction',
	},
	apiInstructionSecondBullet: {
		id: 'eoc.heartbeats.detail.api-instruction.first-bullet.no-translate',
		defaultMessage:
			'Add the relevant information as explained in the <linkApiDocumentation>API documentation</linkApiDocumentation> and make a GET request to the following URL:',
		description: 'Api heartbeat first instruction',
	},
	apiInstructionSecondBulletCreateToken: {
		id: 'eoc.heartbeats.detail.api-instruction.second-bullet.create-token.no-translate',
		defaultMessage: 'Create an API token',
		description: 'Link will redirect user to API token creation page',
	},
	apiInstructionThirdBullet: {
		id: 'eoc.heartbeats.detail.api-instruction.third-bullet.no-translate',
		defaultMessage:
			'Use this token and the heartbeat details to complete the information in the GET request.',
		description: 'Api heartbeat third instruction',
	},
	apiInstructionFourthBullet: {
		id: 'eoc.heartbeats.detail.api-instruction.fourth-bullet.no-translate',
		defaultMessage:
			'Send pings before the ping interval exceeds the limit to prevent the heartbeat from becoming unresponsive.',
		description: 'Api heartbeat fourth instruction',
	},
	copy: {
		id: 'eoc.heartbeats.detail.copy.no-translate',
		defaultMessage: 'Learn more about creating a heartbeat with an API token',
		description: 'Learn more link about API instructions',
	},
	apiTabTitle: {
		id: 'eoc.heartbeats.detail.api-tab-title.no-translate',
		defaultMessage: 'Heartbeats API',
		description: 'Title of the first tab which holds the instruction about API heartbeat',
	},
	emailTabTitle: {
		id: 'eoc.heartbeats.detail.email-tab-title.no-translate',
		defaultMessage: 'Built-in Email',
		description:
			'Title of the second tab which holds the instruction about Built-in email heartbeat',
	},
	emailInstruction: {
		id: 'eoc.heartbeats.detail.email-instruction.no-translate',
		defaultMessage: 'Follow the steps below to send pings to this heartbeat by an email.',
		description:
			'Title of the second tab which holds the instruction about Built-in email heartbeat',
	},
	emailInstructionFirstBullet: {
		id: 'eoc.heartbeats.detail.email-instruction.first-bullet.no-translate',
		defaultMessage:
			'Keep the heartbeat responsive by sending an email to the following email address:',
		description: 'Email heartbeat first instruction',
	},
	emailInstructionSecondBullet: {
		id: 'eoc.heartbeats.detail.email-instruction.first-bullet.no-translate',
		defaultMessage:
			'Send pings before the ping interval exceeds the limit to prevent the heartbeat from becoming unresponsive.',
		description: 'Email heartbeat first instruction',
	},
	emailInstructionLearnMore: {
		id: 'eoc.heartbeats.detail.email-instruction.learn-more.no-translate',
		defaultMessage: 'Read more about creating a heartbeat with a built-in email',
		description: 'Learn more link about Email instructions',
	},
	emailCustomerName: {
		id: 'eoc.heartbeats.detail.email-instruction.customer-name.no-translate',
		defaultMessage: 'customer-name',
		description: 'Email heartbeat customer name',
	},
	transitioningTitle: {
		id: 'eoc.heartbeats.detail.email-instruction.transitioning-title.no-translate',
		defaultMessage: 'Opsgenie heartbeats are now in Jira Service Management',
		description: 'Title of the section message for transitioning customers',
	},
	transitioningMessage: {
		id: 'eoc.heartbeats.detail.email-instruction.transitioning-message.no-translate',
		defaultMessage:
			'We’ve automatically switched any Opsgenie heartbeat email domains to jsmheartbeats.atlassian.net. Your heartbeats will continue to be operational. If you’ve been using any scripts with the Opsgenie heartbeat email, please update your scripts with the new domain.',
		description: 'Content of the section message for transitioning customers',
	},
});

export default messages;
